export default {
  font: {
    color: {
      primary: '#193b4e',
      secondary: '#fff',
    },
  },
};
